import { Box } from '@mui/material';
import HeroSection from '../components/HeroSection';
import ServicesSection from '../components/ServicesSection';
import ProductsSection from '../components/ProductsSection';
import WhySection from '../components/WhySection';
import TestimonialsSection from '../components/TestimonialsSection';
import CTASection from '../components/CTASection';
import ContactSection from '../components/ContactSection';
import SEOHead from '../components/SEOHead';

export default function HomePage() {
  return (
    <>
      <SEOHead />
      <Box component="main" role="main">
        <HeroSection />
        <ServicesSection />
        <ProductsSection />
        <WhySection />
        <TestimonialsSection />
        <CTASection />
        <ContactSection />
      </Box>
    </>
  );
}